'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:travelmerchant:print');
}

var _invoke = require('../invoke');

/**
 * 获取pos 设备id
 *
 * @memberof travel
 * @static
 * @name print
 * @param {Array} content
 * @return {Promise}
 * @example
 *  hbnb.travel.print([
 *    {
        "content":"xxx",
        "gravity":"left", //对齐 left/right/center
        "textsize":"small" //字体大小  small/medium/large
      }
 *  ])
 *      .then(function(resp) {
 *          resp = {
 *              status: 0,
 *              message: '成功'
 *          }
 *      });
 */
module.exports = function(content) {
    if (process.env.NODE_ENV !== 'production') {
        debug('content is %s', content);
    }
    content = content || [];
    var p = new Promise(function(resolve, reject) {
        _invoke('travelmerchant', 'print', {
            content: content,
            callback: function(resp) {
                resolve(resp);
            },
            complete: function (resp) {
                reject(resp);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/travel/biz-pos-print.js
// module id = 642
// module chunks = 0